import type { QueryClient } from '@tanstack/react-query';
import { githubKeys } from '@/hooks/useAgent';

/**
 * Return-URL bootstrap for the GitHub OAuth flow.
 *
 * The server-side callback (`/v1/github/oauth/callback`) finishes by sending
 * the user back to the app at `${web}/lucid?github=connected` (or
 * `?github_error=...`). The token has already been stored server-side; the
 * client just needs to **invalidate** the github token/repos queries so the
 * UI reflects the new connection. We never read the token here — it stays
 * server-side.
 *
 * The Tauri `quon://github/callback` deep-link branch was removed with the
 * Tauri shell (判定ボード D-1, 2026-07-05); on the web build it was
 * unreachable.
 *
 * Idempotent: safe to call once at boot. Returns an unsubscribe function.
 */
export function bootGithubLink(queryClient: QueryClient): () => void {
  if (typeof window !== 'undefined') {
    const params = new URL(window.location.href).searchParams;
    if (params.has('github') || params.has('github_error')) {
      void queryClient.invalidateQueries({ queryKey: githubKeys.token() });
      void queryClient.invalidateQueries({ queryKey: githubKeys.repos() });
    }
  }
  return () => {};
}
